import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Event from '../../entities/event';
import Deadline from '../../entities/deadline';

/*
 * Delete/nullify anywhere this event is used in other entities
 *
 * @param {Event} event
 */
export function deleteEvent(event: Event, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = event.id;
    }
    /* Simple delete usages */
        
    store.getState().deadlines
        .getMappingFor('eventId', event.id)
        .filter(deadlineTemp => deadlineTemp.status !== 'D')
        .forEach(deadlineTemp => {
            const _deadline = deadlineTemp.clone();
            _deadline.status =  'U';
            _deadline.addedOn = newHRTimestamp();
            _deadline.addedBy = getCurrentUserId();
            _deadline.importSource = targetImportSource;
            _deadline.importId = mergeId;

            _deadline.eventId = null;
            store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
        });

    /* Remove the actual event */
    event.status = 'D';
    event.addedOn = newHRTimestamp();
    event.addedBy = getCurrentUserId();
    event.importSource = targetImportSource;
    event.importId = mergeId;
    store.dispatch(Actions.EventActions.removeEventQueue(event));
    
}

/*
 * Replace anywhere this event is used in other entities.
 *
 * @param {Event} event
 * @param {Event} replaceWith
 * @return {Event} - Event will have refs stripped away
 */
export function replaceEvent(event: Event, replaceWith: Event, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = event.id;
    }
    /* Simple replace usages */
        
    store.getState().deadlines
        .getMappingFor('eventId', event.id)
        .filter(deadlineTemp => deadlineTemp.status !== 'D')
        .forEach(deadlineTemp => {
            const _deadline = deadlineTemp.clone();
            _deadline.status =  'U';
            _deadline.addedOn = newHRTimestamp();
            _deadline.addedBy = getCurrentUserId();
            _deadline.importSource = targetImportSource;
            _deadline.importId = mergeId;

            _deadline.eventId = replaceWith.id;
            store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
        });

    return event;
}

/*
 * Determine the impact of deleting this event from other entities
 *
 * @param {Event} event
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactEvent(event: Event) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const deadlineEventIdImpact = state.deadlines
          .getMappingFor('eventId', event.id)
          .filter(deadline => deadline.status !== 'D');

    deadlineEventIdImpact.forEach(() => impacts.push('deadlines'));

    return util.countDistinct(impacts);
}